import { castEnumForDisplay } from "../../helpers/enumHelpers";

export const DAYS_OF_WEEK = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
] as const;

export type DayOfWeekType = (typeof DAYS_OF_WEEK)[number];

export const DAY_OF_WEEK_OPTIONS = DAYS_OF_WEEK.map((day) => ({
  value: day,
  label: castEnumForDisplay(day) ?? day,
}));
